var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.computedComponent,{tag:"component",staticClass:"tw-align-middle tw-inline-block",class:{
    'tw-w-3 tw-h-3': parseInt(_vm.size) === 3,
    'tw-w-4 tw-h-4': parseInt(_vm.size) === 4,
    'tw-w-5 tw-h-5': parseInt(_vm.size) === 5,
    'tw-w-6 tw-h-6': parseInt(_vm.size) === 6,
    'tw-w-7 tw-h-7': parseInt(_vm.size) === 7,
    'tw-w-8 tw-h-8': parseInt(_vm.size) === 8,
    'tw-w-10 tw-h-10': parseInt(_vm.size) === 10,
    'tw-w-12 tw-h-12': parseInt(_vm.size) === 12,
    'tw-w-16 tw-h-16': parseInt(_vm.size) === 16,
  }})}
var staticRenderFns = []

export { render, staticRenderFns }